// @flow

import * as React from 'react';

import { useDispatch } from 'react-redux';

import { updateProduct, type DomainProduct } from '@gandi/cart';
import { notifyDanger } from '@gandi/notifications';
import { useTranslator } from '@gandi/translate';
import { Product } from '@gandi/ui';
import { Custom } from '@gandi/ui-select';

import { Form } from 'gandi.react-form';

import { fetchSmd } from 'src/Tmch/modules/actions';
import { selectSmd } from 'src/Tmch/modules/selector';
import { useAppSelector } from 'src/hooks/useAppSelector';
import type { SMD } from 'src/types';

type Props = {
  product: DomainProduct,
  setSelectedSmdId: string => void,
  setChecking: boolean => void,
  checking: boolean,
};

export default function SmdSelectForm({
  product,
  setChecking,
  setSelectedSmdId,
  checking,
}: Props): React.Node {
  const translator = useTranslator();
  const { __, formatDate } = translator;

  const smdEntries: Array<SMD> = useAppSelector(selectSmd);
  const dispatch = useDispatch();

  const options = smdEntries
    .filter(smd => smd.status === 'active')
    .map(smd => ({
      label: smd.mark_name,
      date: smd.expires_at,
      value: smd.id,
      smdId: smd.smd_id,
    }));

  return (
    <Form
      method="post"
      onSubmit={(evt: SyntheticEvent<HTMLFormElement>) => evt.preventDefault()}
    >
      <Custom
        name="smd-files"
        isDisabled={checking}
        defaultValue={options.find(opt => opt.smdId === product.payload.smd_id)}
        options={options}
        renderOption={data => (
          <Product
            title={data.label}
            key={data.value}
            subtitle={__('valid until %(date)s', {
              date: formatDate(data.date, 'LL'),
            })}
          />
        )}
        onChange={async option => {
          setChecking(true);
          try {
            const smdResponse = await dispatch(fetchSmd(option.value));
            await dispatch(
              updateProduct({
                productId: product.id,
                payload: {
                  ...product.payload,
                  // $FlowFixMe[incompatible-call]
                  smd: smdResponse.data,
                  smd_id: option.smdId,
                },
              }),
            );
            setSelectedSmdId(option.smdId);
          } catch (error) {
            dispatch(notifyDanger(__('Unexpected error occurred')));
          }
          setChecking(false);
        }}
      />
    </Form>
  );
}
